import { StripeConnectState } from './state';

export const stripeConnectInitialState: StripeConnectState = {
};
